// Pending       OrderStatus = "Pending"       // 待支付
// Paid          OrderStatus = "Paid"          // 已支付
// Cancelled     OrderStatus = "Cancelled"     // 取消支付
// RefundRequest OrderStatus = "RefundRequest" // 申请退款审核中
// Refunding     OrderStatus = "Refunding"     // 退款中
// RefundSuccess OrderStatus = "RefundSuccess" // 退款成功
// RefundFailed  OrderStatus = "RefundFailed"  // 退款失败

export const ORDER_STAUTS = [
  {
    label: '全部',
    value: 'All'
  },
  {
    label: '待支付',
    value: 'Pending'
  },
  {
    label: '支付成功',
    value: 'PaidSuccess'
  },
  {
    label: '支付失败',
    value: 'PaidFailed'
  },
  {
    label: '取消支付',
    value: 'Cancelled'
  },
  // {
  //   label: '退款审核中',
  //   value: 'RefundRequest'
  // },
  {
    label: '退款中',
    value: 'Refunding'
  },
  {
    label: '退款成功',
    value: 'RefundSuccess'
  },
  {
    label: '退款失败',
    value: 'RefundFailed'
  }
];
